(function () {
  var root = document.documentElement;
  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  root.classList.add("fpsc-js");

  function initReveal(section) {
    var revealItems = section.querySelectorAll("[data-fpsc-reveal]");

    revealItems.forEach(function (item, index) {
      item.style.setProperty("--fpsc-delay", Math.min(index * 120, 480) + "ms");
    });

    if (reduceMotion || !("IntersectionObserver" in window)) {
      revealItems.forEach(function (item) {
        item.classList.add("fpsc-is-visible");
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) {
            return;
          }

          entry.target.classList.add("fpsc-is-visible");
          observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0.18,
        rootMargin: "0px 0px -8% 0px"
      }
    );

    revealItems.forEach(function (item) {
      observer.observe(item);
    });
  }

  function initSection(section) {
    if (!section || section.dataset.fpscInitialized === "true") {
      return;
    }

    section.dataset.fpscInitialized = "true";
    initReveal(section);
  }

  function initAll() {
    document.querySelectorAll("[data-fpsc-section]").forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    initSection(event.target.querySelector("[data-fpsc-section]"));
  });
})();
